// extracted by mini-css-extract-plugin
export default {"modalContainer":"SeguimientoModal_modalContainer__hHdtn","modal":"SeguimientoModal_modal__7tGVS","closeModal":"SeguimientoModal_closeModal__t9REN"};